import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  getAllGroupStart,
  setCurrentExamGroup,
} from "../../redux/exam-group/reducer";
import {
  selectAllExamGroups,
  selectExamGroupLoading,
  selectCurrentExamGroup,
} from "../../redux/exam-group/selectors";
import usePaginationWrapper from "../general/usePaginationWrapper";

const useExamGroupsGet = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectExamGroupLoading);
  const examGroups = useSelector(selectAllExamGroups);
  const currentExamGroup = useSelector(selectCurrentExamGroup);
  const [fetch, setFetch] = useState(0);
  const refetch = () => setFetch((prev) => prev + 1);
  const [isActive, setIsACtive] = useState({
    label: "Select status",
    value: "",
  });
  const {
    limit,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
  } = usePaginationWrapper({ defaultLimit: 8 });

  const fetchExamGroups = useCallback(() => {
    dispatch(
      getAllGroupStart({
        name: debouncedSearchText,
        size: -1,
        page: page - 1,
        isActive:
          isActive.value === "ACTIVE"
            ? true
            : isActive.value === "INACTIVE"
            ? false
            : "",
      })
    );
  }, [dispatch, page, debouncedSearchText, isActive]);

  const setCurrentGroup = (group) => {
    dispatch(setCurrentExamGroup(group));
  };

  useEffect(() => {
    fetchExamGroups();
  }, [fetchExamGroups, fetch]);

  useEffect(() => {
    if (examGroups) {
      setPageable({
        total_elements: examGroups?.count,
        total_pages: examGroups?.pages,
        number_of_elements: examGroups?.items?.length,
      });
    }
  }, [examGroups, setPageable]);

  return {
    isActive,
    setIsACtive,
    offset,
    setOffset,
    setLimit,
    totalElements,
    totalPages,
    numberOfElements,
    setPageable,
    page,
    setPage,
    limit,
    pageOptions,
    searchText,
    debouncedSearchText,
    setSearchText,
    examGroups,
    loadingExamGroups: isLoading,
    currentExamGroup,
    setCurrentGroup,
    refetch,
  };
};

export default useExamGroupsGet;
